require('./RAImageButton.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const { RadioButton } = require('commonsComponents/radioButton');

class RAImageButton extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange() {
        const { onChange } = this.props;

        return onChange && onChange(this.props);
    }

    buildLabelContent() {
        const { label, size, isSelected } = this.props;
        const labelClassName = classNames('ra-image-button__label', `ra-image-button__label--${size}`);

        return <RadioButton label={label} value={label} className={labelClassName} isChecked={isSelected} />;
    }

    render() {
        const { extraClass, extraClassForGoalWrapper, extraContent, iconType, id, isSelected, label, size } =
            this.props;
        const goalClassName = classNames('ra-image-button', extraClass, `ra-image-button--${size}`, {
            [`icons--icon-objective-${iconType}`]: !!iconType,
            ['icons--icon-objective-none']: !iconType,
        });
        const labelContent = !!label ? this.buildLabelContent() : null;
        const goalWrapperClassName = classNames(
            extraClassForGoalWrapper,
            { 'ra-image-button__selected': isSelected && !!iconType },
            {
                [`ra-image-button-goalcontent--${size}`]: !!iconType,
                [`ra-image-button-goalcontent--${size} ra-image-button-goalcontent--${size}--default-icon`]: !iconType,
            }
        );

        return (
            <div className="ra-image-button-container" onClick={this.handleChange}>
                <div className={goalWrapperClassName}>
                    <i className={goalClassName} id={id}>
                        {extraContent}
                    </i>
                </div>
                {labelContent}
            </div>
        );
    }
}

RAImageButton.propTypes = {
    extraClass: PropTypes.string,
    extraClassForGoalWrapper: PropTypes.string,
    extraContent: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    iconType: PropTypes.string.isRequired,
    id: PropTypes.string,
    isSelected: PropTypes.bool,
    label: PropTypes.string,
    onChange: PropTypes.func,
    size: PropTypes.string,
};

RAImageButton.defaultProps = {
    isSelected: false,
    size: 'medium',
};

module.exports = RAImageButton;
